import React from 'react';
import { ShoppingBag, Shirt, Coffee, Briefcase } from 'lucide-react';
import { Button } from './ui/Button';
export function FeaturedProducts() {
  const categories = [{
    icon: <Shirt className="w-8 h-8" data-id="element-43" />,
    title: 'Custom Apparel',
    description: 'T-shirts, hoodies, polos, and more',
    accentColor: 'pink' as const
  }, {
    icon: <Coffee className="w-8 h-8" data-id="element-44" />,
    title: 'Personalized Gifts',
    description: 'Mugs, tote bags, and custom items',
    accentColor: 'yellow' as const
  }, {
    icon: <Briefcase className="w-8 h-8" data-id="element-45" />,
    title: 'Corporate Products',
    description: 'Branded merchandise and uniforms',
    accentColor: 'teal' as const
  }, {
    icon: <ShoppingBag className="w-8 h-8" data-id="element-46" />,
    title: 'Promotional Items',
    description: 'Giveaways and marketing materials',
    accentColor: 'pink' as const
  }];
  const accentColors = {
    pink: 'text-wh-pink bg-pink-50 border-pink-100',
    yellow: 'text-wh-yellow bg-yellow-50 border-yellow-100',
    teal: 'text-wh-teal bg-teal-50 border-teal-100'
  };
  return <section className="py-24 bg-gray-50" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="text-center mb-16" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-50">
            Shop Custom Products
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-51">
            Browse our product catalog or create something completely custom.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-52">
          {categories.map((category, index) => <div key={index} className="group bg-white p-8 rounded-xl border border-gray-100 hover:shadow-lg transition-all duration-300 cursor-pointer text-center" data-id="element-53">
              <div className={`w-16 h-16 rounded-xl ${accentColors[category.accentColor]} border-2 flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform`} data-id="element-54">
                {category.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-55">
                {category.title}
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-56">{category.description}</p>
            </div>)}
        </div>

        <div className="text-center flex flex-col sm:flex-row gap-4 justify-center" data-id="element-57">
          <Button variant="primary" size="lg" data-id="element-58">
            Shop Custom Products
          </Button>
          <Button variant="outline" size="lg" data-id="element-59">
            Browse Product Catalogs
          </Button>
        </div>
      </div>
    </section>;
}